<script>
export default {
    data() {
        this.fetchAttendants = _.debounce(this.fetchAttendants, 800)
        return {
            data: [],
            value: [],
            fetching: false,
        }
    },
    methods: {
        fetchAttendants(value) {

        }
    }
}
</script>
